import React from 'react';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import Tooltip from 'src/components/Tooltip/Tooltip';
import ExpandableText from 'src/components/ExpandableText/ExpandableText';
import { IServiceRequest } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import './DescriptionCell.scss';

interface DescriptionCellProps {
  serviceRequest: IServiceRequest;
}

const SUBSCRIBED_TOOLTIP_CONTENT: string =
  "You're subscribed to updates on this service request but are not assigned to it.";

export const DescriptionCell = ({ serviceRequest }: DescriptionCellProps) => {
  const description: string = serviceRequest.description?.trim() ?? '';

  return (
    <div className="description-cell">
      <ExpandableText text={description} characterLimit={80} />
      {serviceRequest.isSubscribed && (
        <Tooltip content={SUBSCRIBED_TOOLTIP_CONTENT}>
          <CategoryPill
            text="Subscribed"
            size="small"
            color="#000"
            textColor="#fff"
            iconGlyph="bell"
            iconWeight="solid"
          />
        </Tooltip>
      )}
    </div>
  );
};
